import create, { GetState, SetState } from "zustand";

import { ViewerFragment } from "../graphql/generated/definitions";

import { createReportSlice, ReportStore } from "./report";

type ViewerState = {
  viewer?: ViewerFragment;
  setViewer: (viewer: ViewerFragment) => void;
};

const createViewerSlice = (set: SetState<State>, get: GetState<State>): ViewerState => ({
  viewer: undefined,
  setViewer: (viewer) => set(() => ({ viewer })),
});

export type State = ViewerState & ReportStore;

const useStore = create<State>((set, get) => ({
  ...createViewerSlice(set, get),
  ...createReportSlice(set, get),
}));

export default useStore;
